<template>
	<div class="ry-form__fill-btn-list">
		<div
			class="btn-item"
			@click="show = true"
			v-if="hideBtn.length"
		>
			<!-- <van-icon
				size="22"
				name="more-o"
			>
			</van-icon> -->
			<div>更多</div>
		</div>
		<div class="other-btn-container">
			<div class="btn-list">
				<div
					class="btn-tmp"
					v-for="opt in showBtn"
					:key="opt.originName"
					@click="feedback(opt)"
				>
					<van-button type="primary" size="small">{{opt.customName}}</van-button>
				</div>
				<van-action-sheet
					v-model="show"
					get-container="body"
					:actions="hideBtn"
					@select="popupClick"
				>
				</van-action-sheet>
				<div
					v-if="firstBtn"
					class="first-btn"
					:class="{'only-btn' : !hideBtn.length && !showBtn.length}"
					:style="{backgroundColor: firstBtn.customColor, borderColor: firstBtn.customColor, color: firstBtn.textColor}"
					@click="feedback(firstBtn)"
				>
					<van-button type="primary" size="small">{{firstBtn.customName}}</van-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			btnList: {
				type: Array,
				default: []
			},
			feedback: {
				type: Function,
				default: (info) => {}
			}
		},
		data() {
			return {
				popoverVisible: false,
				show: false
			}
		},
		created() {},
		computed: {

			// 折叠按钮
			hideBtn() {
				return this.btnList.slice(3).map(item => {
					item.name = item.customName
					item.color = '#333333'
					return item
				})
			},
			// 明面按钮
			showBtn() {
				return this.btnList.slice(1, 3)
			},
			// 第一个按钮
			firstBtn() {
				return this.btnList[0] || {}
			}
		},
		methods: {
			computedStyle(opt) {
				return {
					backgroundColor: opt.customColor,
					color: opt.textColor
				}
			},

			popupClick(info) {
				this.feedback(info)
				this.show = false
			}
		}
	}
</script>


<style lang="less">
	.ry-form__fill-btn-list {
		display: flex;
		height: 100%;
		width: 100%;


		.only-btn {
			width: 100%;
		}
		
		.btn-item {
			font-size: 14px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			color: #7F8389;
			margin-left: 10px;
		
			>div {
				margin-top: 5px;
			}
		
			i {
				font-size: 20px;
			}
		}

		.other-btn-container {
			flex: 1;
			display: flex;
			justify-content: flex-end;
			align-items: center;

			
			.btn-list{
				display: flex;
				
				.first-btn {
					margin: 0 10px;
					.van-button{
						background-color: #4260FA;
						color: #fff;
						border: none;
						padding: 0 15px;
					}
				}
				
				.btn-tmp{
					margin: 0 10px;
					.van-button{
						background-color: #DFE8FF;
						color: #4260FA;
						border: none;
						padding: 0 15px;
					}
				}
			}
		}

		/*.btn-item {*/
		/*  height: 100%;*/
		/*  line-height: 50px;*/
		/*  text-align: center;*/
		/*  border-right: 1px solid #ebedf0;*/
		/*  font-size: 14px;*/

		/*  &:not(.ellipsis-btn) {*/
		/*    flex: 1;*/
		/*  }*/

		/*  &.ellipsis-btn {*/
		/*    box-sizing: border-box;*/
		/*    width: 80px;*/
		/*    line-height: 24px;*/
		/*    padding: 13px 0;*/
		/*  }*/

		/*  &:last-child {*/
		/*    border-right: none;*/
		/*  }*/
		/*}*/

	}
</style>
